enum Language {
  GREEK = 'GREEK',
  ENGLISH = 'ENGLISH',
  RUSSIAN = 'RUSSIAN',
  ALBANIAN = 'ALBANIAN',
}

export default Language
